import { all } from 'redux-saga/effects'

import watchCompaniesSaga from './companies'
import watchPositionsSaga from './positions'

export default function* positionsDashboardSaga() {
  yield all([watchCompaniesSaga(), watchPositionsSaga()])
}
